import { isEmpty } from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { UserContext } from '../auth/UserContext';
import { fetchAttachmentUrl } from './attachments';

const free = (objectUrl: string) => {
    // console.log('Freeing:', objectUrl);
    URL.revokeObjectURL(objectUrl);
};

export default (attachmentId: string) => {
    const [attachment, setAttachment] = useState<string>('');
    const { activeOrganizationAccount } = useContext(UserContext);

    useEffect(() => {
        let objectUrl: string;

        if (!isEmpty(attachmentId) && attachmentId !== 'null') {
            fetchAttachmentUrl(attachmentId, activeOrganizationAccount)
                .then((url) => {
                    objectUrl = url;
                    setAttachment(url);
                })
                .catch(() => setAttachment(''));
        } else {
            setAttachment('');
        }

        return () => {
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [attachmentId, activeOrganizationAccount]);

    return { attachment, free: () => URL.revokeObjectURL(attachment) };
};
